/* Packages */
import React from 'react';
import { createRoot } from 'react-dom/client';

const vehicleOverviewNodes = Array.from(document.querySelectorAll('[data-vehicle-overview]'));

if (vehicleOverviewNodes.length) {
    import(/* webpackChunkName: "VehicleOverview" */ './components/VehicleOverview').then(({ default: VehicleOverview }) => {
        vehicleOverviewNodes.forEach((node) => {
            const root = createRoot(node);
            root.render(<VehicleOverview {...(JSON.parse(node.dataset.vehicleOverview || '{}'))} />);
        });
    });
}
